import React, {useState, useEffect} from "react";
import { Link } from "react-router-dom";
import "./education.css";
function Categories(props) {
  const [categories, setCategories] =  useState([...new Set(props.data && props.data.map(item => item.field))]);
  useEffect(() => {
    setCategories([...new Set(props.data && props.data.map(item => item.field))]) 
  }, [props.data]);
  return (
    <div className="categoryBlock">
      <div className="categoryTitle">Categories</div>
      <div
        className={ props.title!=="All Our Workshops" ? "category" : "categorySelected"}
        onClick={()=>{
          props.selectFormation("");
          props.getTitle("All Our Workshops")
          props.getWorkshops(props.data);
          props.getFilter(false);
        }}
      >
        All Our Workshops
      </div>
      {categories && categories.map((e, index) => (
          <div
            className={
              e !== props.title? "category" : "categorySelected"
            }
            onClick={() => {
              props.selectFormation("");
              props.getTitle(e)
              const workshopPerCategory = [];
              props.data.map((e2) => {
                if (
                  e === e2.field &&
                  !workshopPerCategory.includes(e2)
                ) {
                  workshopPerCategory.push(e2);
               
                }

              });
              props.getWorkshops(workshopPerCategory)
              props.getFilter(true);
            }}
            key={index}
          >
            {e}
          </div>
        ))}




    </div>
  );
}

export default Categories;
